import React from 'react';

function NCH1() {
  return (
    <div>

        <div className="container mt-5 mb-5">

            <div className="row register" style={{ maxWidth: "100%" }}>
                <div className="col-md-12">
                  <h4>
                  	Link for all related bodies of the Central government, state government and union territory Administration:        
                  </h4>
                </div>

        
                <div className="container">  
                  <div className="alumni-area mt-4">
                    <div className="row">
                      <div className="col-md-10">
         
                            <h6>1. National Commission for Homoeopathy : <a href="https://nch.org.in/">https://nch.org.in/</a></h6>
                            <br/>
                            <h6>2. AYUSH Department : <a href="https://ayush.gov.in/">https://ayush.gov.in/</a></h6>
                            <br/>
                            <h6>3. Ayush Bisag Portal : <a href="https://ayushedu.bisag-n.gov.in/AYUSH_EDU/landingpage">https://ayushedu.bisag-n.gov.in/AYUSH_EDU/landingpage</a></h6>
                            <br/> 
                            <h6>4. Ayush Gujarat : <a href="https://ayush.gujarat.gov.in/">https://ayush.gujarat.gov.in/</a></h6>
                            <br/>
                            <h6>5. Ministry of Health & Family Welfare : <a href="https://main.mohfw.gov.in/ ">https://main.mohfw.gov.in/ </a></h6>
                            <br/>
                            <h6>6. Department of Health Research : <a href="https://dhr.gov.in/ ">https://dhr.gov.in/ </a></h6>

                      </div>
                    </div>
                  </div>
                </div>
         
            </div>
       
        </div>
      
    </div>
  )
}

export default NCH1;
